<template>
  <div class="historyComponent">
    <van-list
      v-model="loading"
      :offset="300"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="(item,index) in NewhistoryList" :key="index" class="content">
        <p class="monthHistory-title">{{ item.groupName }}</p>
        <!--        <p class="monthHistory-subtitle">消费：￥{{ item.amount }}</p>-->
        <div
          v-for="(historyItem,index) in item.data"
          :key="index"
          class="item"
          @click="goHistoryDetail(historyItem.id)"
        >
          <div class="monthHistory-detail">
            <div class="title">
              <div class="moneyIcon">￥</div>
              <div class="monthHistory-detail-left">
                <p>
                  <span class="left-name hasMar">{{ historyItem.mealRuleName | filterName }}</span>
                </p>
                <p>
                  <span class="hasMar">{{ historyItem.createTime }}</span>
                </p>
              </div>
            </div>
            <div class="monthHistory-detail-right">
              <div class="consumeFee">-{{ historyItem.consumeFee }}</div>
            </div>
          </div>
          <div v-if="historyItem.couponName" class="couponName">
            <van-tag type="primary">{{ historyItem.couponName || '' }}{{ historyItem.couponSerial || '' }}</van-tag>
          </div>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
// import QRCode from 'qrcodejs2'
// import { RefreshQrcode } from '@/api/user'
import { consumeList } from '@/api/user';

export default {
  name: 'HistoryComponent',
  filters: {
    filterName(val) {
      if (val.length > 12) {
        let str = '';
        str = val.substring(0, 12) + '...';
        return str;
      } else {
        return val;
      }
    }
  },
  props: {
    size: {
      type: Number,
      default() {
        return 10;
      }
    },
    activeName: {
      type: String,
      default() {
        return '';
      }
    },
    visiDate: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      page: 1,
      total: null,
      loading: false,
      personalInfo: {},
      todayTime: '',
      historyList: [],
      NewhistoryList: [], // 处理统一字段后的historyList
      messageId: '' // 从消息模板进来打开二维码的id
    };
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.size);
    },
    finished() {
      return this.page > this.maxPage;
    }
  },
  watch: {
    activeName: {
      handler(nv) {
        this.getList(nv);
      },
      immediate: true
    },
    historyList: {
      handler(nv) {
        var groupList = [];
        var list = nv.map(val => {
          const createTime = val.createTime || '';
          const groupName = `${createTime.split(' ')[0].split('-')[0]}年${createTime.split(' ')[0].split('-')[1]}月`;
          groupList.push(groupName);
          return {
            ...val,
            groupName,
            createTime: val.createTime.slice(-14, -3),
            createDate: `${createTime.split(' ')[0].split('-')[1]}月${createTime.split(' ')[0].split('-')[2]}日`
          };
        });
        groupList = [...new Set(groupList)].map(v => {
          var data = [];
          let amount = 0;
          list.forEach(val => {
            if (v === val.groupName) {
              data.push(val);
              amount = amount + Number(val.consumeFee);
            }
          });
          return {
            groupName: v,
            data,
            amount
          };
        });
        this.NewhistoryList = groupList;
        this.loading = false;
      },
      // immediate: true
      deep: true
    }
  },
  activated() {
    if (this.page !== 1 || this.historyList.length) {
      this.page = 1;
      this.historyList = [];
      this.getList(this.activeName);
    }
  },
  created() {
    this.personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
  },
  methods: {
    // 申请记录
    getList() {
      const data = {
        page: this.page,
        size: this.size
      };
      consumeList(data).then(res => {
        this.historyList.push(...res.data.list);
        this.total = res.data.totals;
      });
    },
    onLoad() {
      if (this.page > this.maxPage) {
        return;
      } else {
        ++this.page;
      }
      this.getList(this.activeName);
    },
    goHistoryDetail(id) {
      this.$router.push({ name: 'recordInfo', query: { id: id }});
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}

.historyComponent {
  /deep/.van-cell {
    padding: 0rem !important;
  }
  .van-cell__value {
    width: 100%;
  }
  .content {
    //  padding: 0rem 0.15rem;
    .monthHistory-title {
      padding-top: 0.1rem;
      padding-bottom: 0.1rem;
      padding-left: 0.15rem;
      background: rgba(239, 239, 244, 1);
    }

    .monthHistory-subtitle {
      .change_val(font-size, 24);
      padding: 0rem 0.15rem;
      background: rgba(239, 239, 244, 1);
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      opacity: 1;
    }

    .item {
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      .couponName {
        display: flex;
        justify-content: flex-end;
        margin-top: -0.15rem;
        .change_val(margin-bottom, 10);
        margin-right: 0.18rem;
      }
      .monthHistory-detail {
        display: flex;
        justify-content: space-between;
        font-size: 0.14rem;
        color: rgba(51, 51, 51, 0.7);
        background: #fff;
        .title {
          display: flex;
          align-items: center;
          .moneyIcon {
            .change_val(width, 72);
            .change_val(height, 72);
            .change_val(font-size, 36);
            .change_val(margin-left, 30);
            background: #3B86FF;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #FFFFFF;
          }
          .monthHistory-detail-left {
            padding: 0.16rem 0.15rem;
            .theme {
              font-size: 0.17rem;
              font-weight: 400;
              line-height: 0.18rem;
              color: #001833;
            }
            p {
              height: 0.24rem;
              line-height: 0.24rem;
              .left-name {
                font-size: 0.17rem;
                color: #001833;
              }
              .hasMar {
                margin-right: 0.16rem;
              }
            }
            p:first-child {
              margin-bottom: 0.02rem;
            }
          }
        }
        .monthHistory-detail-right {
          display: flex;
          align-items: center;
          line-height: 100%;
          margin-right: 0.18rem;

          .consumeFee {
            .change_val(font-size, 34);
            font-family: PingFang SC;
            font-weight: 400;
            color: #001833;
          }

          .right-icon {
            margin-right: 0.18rem;
            .svg-icon {
              width: 0.28rem;
              height: 0.28rem;
            }
            > img {
              width: 0.28rem;
              height: 0.28rem;
            }
          }
          .AUDIT_CANCEL,
          .UNVISIT,
          .AUDIT_FAIL,
          .AUDIT_OUTTIME {
            color: rgba(51, 51, 51, 0.5);
          }
          .AUDIT_WAITTING,
          .WAITING_VERIFY {
            color: #f2b230;
          }
          .OUTTIME_VISIT,
          .AUDIT_REJECT {
            color: #f76260;
          }
          .VISITING,
          .WAITING_VISIT {
            color: #3b86ff;
          }
          .FINISH,
          .AUDIT_PASS {
            color: #2dcc2c;
          }
        }
      }
    }
    //
    //.monthHistory-detail:not(:last-child) {
    //  border-bottom: 1px solid rgba(229, 229, 229, 1);
    //}
  }
}
</style>
